<template>
  <menu-item-group
    :item="item"
    text
    sub-group
  />
</template>

<script>
export default {
  name: 'MenuItemSubGroup',
  props: {
    item: {
      type: Object,
      default: () => ({
        avatar: undefined,
        group: undefined,
        title: undefined,
        children: []
      })
    }
  }
}
</script>
